var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXpla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B1FF",
    d: "M24 48c13.26 0 24-10.74 24-24S37.26 0 24 0 0 10.74 0 24s10.74 24 24 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.435 25.71-1.695 1.695 11.64 11.67 1.695-1.695-11.64-11.67ZM10.59 8.895 8.895 10.59l11.67 11.67 1.695-1.695-11.67-11.67Zm26.775.03-11.64 11.67 1.695 1.695 11.64-11.67-1.695-1.695ZM20.595 25.74 8.955 37.41l1.695 1.695 11.64-11.67-1.695-1.695Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpla);
export default __webpack_public_path__ + "static/media/xpla.39d25b51bf8a5b7f6aeb01cd57c5ec61.svg";
export { ForwardRef as ReactComponent };